import { render } from "./ConsultaEstadistico.vue?vue&type=template&id=8867cd12"
import script from "./ConsultaEstadistico.vue?vue&type=script&lang=js"
export * from "./ConsultaEstadistico.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__